// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const hitmonchan: PokeData = {
  "id": 107,
  "name": "hitmonchan",
  "height": 14,
  "weight": 502,
  "base_experience": 159,
  "types": [
    PokeType.FIGHTING
  ],
  "api_moves": [
    "comet-punch",
    "mega-punch",
    "fire-punch",
    "ice-punch",
    "thunder-punch",
    "tackle",
    "leer",
    "counter",
    "agility",
    "focus-energy",
    "swift",
    "dizzy-punch",
    "mach-punch",
    "detect",
    "pursuit",
    "fake-out",
    "focus-punch",
    "helping-hand",
    "revenge",
    "sky-uppercut",
    "feint",
    "close-combat",
    "drain-punch",
    "vacuum-wave",
    "bullet-punch",
    "quick-guard",
    "power-up-punch"
  ],
  "moves": [
    "fire-punch",
    "ice-punch",
    "thunder-punch",
    "tackle",
    "leer",
    "pursuit",
    "close-combat",
    "drain-punch",
    "vacuum-wave",
    "coaching",
    "rolling-kick",
    "bulk-up",
    "karate-chop"
  ],
  "evolution_chain": {
    "id": 47,
    "item": null,
    "species": [
      {
        "name": "tyrogue",
        "order": 115,
        "types": [
          PokeType.FIGHTING
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "hitmonlee",
        "order": 116,
        "types": [
          PokeType.FIGHTING
        ],
        "evolves_from_species_id": 236,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 20,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": 1,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "hitmonchan",
        "order": 117,
        "types": [
          PokeType.FIGHTING
        ],
        "evolves_from_species_id": 236,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 20,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": -1,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "hitmontop",
        "order": 118,
        "types": [
          PokeType.FIGHTING
        ],
        "evolves_from_species_id": 236,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 20,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": 0,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 114,
    "speed": 120,
    "ability_power": 166
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
